import React from 'react';
import { AppBar, TitlePortal } from 'react-admin';
import { Typography, Box } from '@mui/material';
import axios from "axios";
import { useQuery } from "react-query";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
};

// La fonction de fetch doit être définie à l'extérieur ou avant
const fetchTimeOfLastUpdate = async () => {
    const res = await axios.get(`${API_URL}/hqlogs/lastupdate`, {
        headers: getAuthHeaders(),
    });
    return res.data;
};

export const CustomAppBar = (props) => {
    const { data: lastUpdate, isLoading } = useQuery(
        ["hqlogs", "lastupdate"],
        fetchTimeOfLastUpdate
    );

const formatDate = (dateString) => {
    if (!dateString) return "--/--";
    const date = new Date(dateString);
    const tz = "Europe/Paris";
    return date.toLocaleString('fr-FR', { timeZone: tz },{
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).replace(',', ''); // Enlève la virgule entre la date et l'heure
};
    return (
        <AppBar {...props}>
    {/* ZONE GAUCHE : On met le TitlePortal ici */}
    {/* <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}> */}
        <TitlePortal variant='h6' component="h3" />
    {/* </Box> */}

    {/* ZONE CENTRALE : Vos infos de mise à jour */}
    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {!isLoading && lastUpdate && (
            <Box sx={{ 
                display: 'flex', 
                gap: 4, 
                fontSize: '0.75rem',
                backgroundColor: 'rgba(0,0,0,0.1)',
                padding: '4px 16px',
                borderRadius: '20px',
                whiteSpace: 'nowrap' // Empêche le texte de revenir à la ligne
            }}>
                <Box>
                    <span style={{ opacity: 0.7 }}>Last Trainings Sync:</span> {formatDate(lastUpdate.lastUpdateTraining?.last_touched_dt)}
                </Box>
                <Box>
                    <span style={{ opacity: 0.7 }}>Last Users Sync:</span> {formatDate(lastUpdate.lastUpdateUser?.last_touched_dt)}
                </Box>
                <Box>
                    <span style={{ opacity: 0.7 }}>Next Sync:</span> {formatDate(lastUpdate.nextSyncDate)}
                </Box>
            </Box>
        )}
    </Box>

    {/* ZONE DROITE : Vide (ou pour d'autres boutons) pour équilibrer le centrage */}
    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
        {/* Vous pouvez laisser vide ou mettre un bouton ici */}
    </Box>
</AppBar>

    );
};